import { render, staticRenderFns } from "./FreeCoupton.vue?vue&type=template&id=14d2f6dc&scoped=true&"
import script from "./FreeCoupton.vue?vue&type=script&lang=js&"
export * from "./FreeCoupton.vue?vue&type=script&lang=js&"
import style0 from "./FreeCoupton.vue?vue&type=style&index=0&id=14d2f6dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d2f6dc",
  null
  
)

export default component.exports